import type { DeepPartial } from '../../default/types';
import type { OrderConfig } from '../../default/order/order.types';

export const orderConfig: DeepPartial<OrderConfig> = {
  premium: {
    enabled: true,
    hasRuntimeOptions: false,
    hasLegalFooter: true,
  },
};
